export const tokenize = (str: string) => {
  const nonWordRegex = /[^a-z0-9\-\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]+/i
  return str.split(nonWordRegex)
    .filter(Boolean)
}

export const tokenizer = {
  tokenize
}
